import React from 'react';
import { Form, Row, Col, Button, Divider, message } from "antd";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import  OnboardingService  from 'services/onboarding-service';
import  { COMPANY_BACKGROUND_FIELDS }  from "constants/form-fields";
import moment from "moment";

class CompanyBackgroundForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);
    state = {
        formValues: {},
    }

    handleFieldValueChange = (fieldName, value) => {
    }

    onApprove = (e) => {
        e.preventDefault();
        const formValues = {};
        const formFields = COMPANY_BACKGROUND_FIELDS;
        formFields.forEach((field, fieldName) => {
            formValues[fieldName] = this.props.form.getFieldValue(fieldName);
        });

        this.props.form.validateFields((err, values) => {
            if (!err) {
                const formData = this.props.form.getFieldsValue();
                formData["company_id"] = Number(this.props.companyId)
                formData["mpa_approval"] = this.props.currentMpaId
                formData["date_of_incorporation"] = formData?.date_of_incorporation?.format("YYYY-MM-DD")
                if(this.props.companyBackgroundData?.size>0){
                    OnboardingService.postCompanyBackgroundApi("patch", this.props.companyBackgroundData?.get("id"), formData).then(res=>{
                        if(res.status === 200){
                            message.success("Data Updated")
                        }
                    }).catch((err)=>{
                        console.log("inside catch background", err);
                        message.error(err && err?.data?.detail || "Something went wrong")
                    })
                }else{
                    OnboardingService.postCompanyBackgroundApi("post", null, formData).then(res=>{
                        message.success("Data Updated")
                    }).catch((err)=>{
                        console.log("inside catch background", err);
                        message.error(err ? typeof err === "object" && Object.values(err)[0] : "Something went wrong");
                    })
                }
            }
        })
    }

    getFormValues = (formKey) => {
        const formValues = {};
        const formFields = this.state.forms[formKey];
        for (const fieldName in formFields) {
            formValues[fieldName] = formFields[fieldName].value;
        }
        return formValues;
    }

    render() {
        return (
            <div className={"d-flex flex-row justify-content-space-between flex-wrap w-100 form"}>
                <Form key="feeForm" onSubmit={this.onApprove}>
                    <Row>
                        {COMPANY_BACKGROUND_FIELDS.map((field, fieldName) => {
                            // field.disabled = this.props.disableFields;
                            const value = this.props.values && this.props.values.get(fieldName);
                            const corporation_type = this.props.values.getIn(["company", "corporation_type"]);
                           if(fieldName === "series_funded" && corporation_type === "New Age Company"){
                                field.rules = [
                                    {
                                        required: true,
                                        message: "Field is Required"
                                    },
                                ]
                        }
                            return <Col span={field.col}>{this.fieldGenerator(
                                fieldName,
                                { ...field, value },
                                this.getValidateStatus(fieldName),
                                (e) => this.handleFieldValueChange(fieldName, (field.type == "SELECT" ? e :  e.target.value)),
                                true
                            )()}</Col>
                        }).toList()}
                    </Row>
                    <Row>
                        <Col span="20"></Col>
                        <Col span="4"><Button type="primary" block htmlType="submit">Save</Button></Col>
                    </Row>
                </Form>
                <Divider />
            </div>
        );
    }
}
export default Form.create({
    mapPropsToFields: ({values, companyBackgroundData }) => {
        if (!companyBackgroundData) {
            return new Map();
        }
        const fields = {};

        companyBackgroundData.forEach((value, key) => {
            if (key === "company") {
                fields["industry"] = Form.createFormField({
                    value: value?.industry || ""
                });

                fields["date_of_incorporation"] = Form.createFormField({
                    value: value?.date_of_incorporation ? moment(value.date_of_incorporation) : null
                });
            } else {
                fields[key] = Form.createFormField({
                    value
                });
            }
        });
        return fields;
    },
    onValuesChange: (props, changedValues, values) => {
    }
})(CompanyBackgroundForm);
